<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="">
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <span class="title-css">THÔNG TIN CHUNG</span>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <label class="txt-right">Công ty</label>
              <InputText disabled v-model="company.name" type="text" class="input-text-box cs-input"/>
            </div>
            <div class="mt-2">
              <label class="txt-right">Tên gọi SRA</label>
              <InputText disabled v-model="sra.name" type="text" class="input-text-box cs-input"/>
            </div>
            <div class="mt-2">
              <label class="txt-right">Nhà thầu</label>
              <InputText disabled v-model="contractor.label" type="text" class="input-text-box cs-input"/>
            </div>
          </div>
          <div class="f-grid-col">
            <!-- <div class="mt-2">
              <label class="txt-right">Hồ sơ</label>
              <InputText disabled v-model="sample_license.name" type="text" class="input-text-box cs-input"/>
            </div> -->
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-3">
              <table id="tb_level">
                <tr>
                  <th style="width:50px;text-align:center !important;">STT</th>
                  <th style="text-align:center !important;">Tên tiêu chí</th>
                  <th style="width:104px;text-align:center !important;">Hồ sơ</th>
                  <th style="">Ghi chú của NT</th>
                  <th style="width:100px;text-align:center !important;">Duyệt hồ sơ</th>
                  <th style="width:120px;text-align:center !important;">Người cập nhật</th>
                  <th style="width:130px;text-align:center !important;">Cập nhật cuối</th>
                  <!-- <th style="width:90px"></th> -->
                </tr>
                <tr v-for="(item, index) in list_profile" :key="index">
                  <td>{{index+1}}</td>
                  <td>{{item.sample_license_name}}</td>
                  <td>
                    <div v-if="item.files.length > 0"><span class="download-file-cs" v-on:click="downloadFiles(item.files)">Tải {{item.files.length}} file</span></div>
                  </td>
                  <td style="white-space: pre-wrap;" v-html="item.note"></td>
                  <td style="text-align: center;">
                    <Checkbox :disabled="true" v-if="type_company !=='contractor'" v-model="item.status_check" :binary="true" style="margin-right: 0px;"/>
                    <div v-else style="text-align: left;">
                      <span v-if="item.status == 'NEEDS_UPDATE'"></span>
                      <span v-if="item.status == 'WAITTING'">Chờ duyệt</span>
                      <span v-if="item.status == 'APPROVED'" style="color:#00973C;font-weight: bold;">Đã duyệt</span>
                      <span v-if="item.status == 'REJECTED'" style="color:#E93838;font-weight: bold;">Từ chối</span>
                    </div>
                  </td>
                  <td>{{item.updated_fullname}}</td>
                  <td>{{item.time}}</td>
                  <!-- <td style="text-align: center;" >
                    <Button
                      :disabled="item.upload_disable==true"
                      @click="ShowUpload(index)"
                      icon="pi pi-upload"
                      class="button-box p-button-add"
                    >
                    </Button>
                  </td> -->
                </tr>
              </table>
            </div>
          </div>
        </div>
        <div class="f-grid" style="margin: 0px 10px 0px 10px;">
          <div class="f-grid-col">
            <div class="mt-2">
              <div class="mt-2">
                <label class="txt-right">Lý do từ chối</label>
                <Textarea
                  disabled
                  id="note_add"
                  v-model="note"
                  :autoResize="true"
                  rows="2"
                  maxlength="14000"
                  :class="{ 'input-text-box' : true, 'cs-warning-cls' : is_warning == true }"
                  placeholder="Nhập"
                />
              </div>
            </div>
          </div>
          <div class="f-grid-col">
            
          </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <!-- <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" /> -->
        </template>
      </Toolbar>

      <Dialog header="Tải tệp" :visible.sync="showEditDialog" :contentStyle="{overflow: 'visible','overflow-y': 'scroll'}" :modal="true">
        <div style="padding-top: 0px;min-width:400px;">
          <input class="input_tmp_validator" id="files">
          <div class="cus-text">Dung lượng tối đa: 50 MB</div>
          <div class="cus-text">Định dạng file: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg.</div>
          <input class="p-inputtext p-component text-box-a" multiple style="background-color: #EEEEEE;" accept=".docx, .doc, .xlsx, .xls, .pptx, .pdf, .png, .jpg, .jpeg" name="files[]" type="file" @change="onFileSelect2"/>
          <div class="box-images text-box-a" v-if="profile_info && profile_info.files && profile_info.files.length > 0">
            <div class="d-flex align-items-center" v-for="(item, index) in profile_info.files" :key="index" >
              <div class="file-name" @click="openFile(item)" style="cursor: pointer; color: blue; text-decoration: underline;">{{ item.name }}</div>
              <div v-if="loading" class="loading-overlay">
                <div class="spinner"></div>
                <p>Đang tải lên...</p>
              </div>
              <Button icon="pi pi-download" class="p-button-download p-button-link" @click="onFileDownload(index)"/>
              <Button icon="pi pi-trash" class="p-button-secondary p-button-link text-danger" @click="onFileClear2(index)"/>
            </div>
          </div>
        </div>
        <template #footer>
          <Button label="Hủy" @click="showEditDialog = false" icon="pi pi-times" class="p-button-cancel-2"/>
          <Button type="button" label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
        </template>
      </Dialog>
    </div>
  </form>
</template>

<script>
// import DropdownScrollable from '@/components/DropdownScrollable_v2.vue';
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
import jq from 'jquery';
export default {
  components:{
    // DropdownScrollable
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      type_company : null,
      sra : {id : null, name : ''},
      note : "",
      is_required : true,
      filters: {},
      maxFileSize: 10485760*5,//1024*1024*50 = 50MB
      maxFiles : 100,
      name: "",
      active: true,
      company: {},
      items: [],
      total: 0,
      loading: false,
      offset: 0,
      maxFilesProfile: 100,
      list_profile : [],
      profile_info : null,
      showEditDialog : false,
      index_update : -1,
      filesDeletes : [],
      detail_id : null,
      filesDeletes2 : [],
      filesDeletes2_tmp : [],
      filesDelete_root : [],
      filesDelete_root_tmp : [],
      contractor : {},
      type_list : [
        {value : 'contractor', label :'Hồ sơ nhà thầu'},
        {value : 'user', label :'Nhân sự'},
        {value : 'equipment', label :'Thiết bị'},
        {value : 'supplies', label :'Vật tư'},
      ],
      seltype : null,
      previousSelType : null,
      users1_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      selusers1 : null,
      work_position : '',
      list_profile_users : [],
      status_list : [
        {value : 'WAITTING', label :'Chờ duyệt'},
        {value : 'APPROVED', label :'Đã duyệt'},
        {value : 'REJECTED', label :'Từ chối'},
      ],
      selstatus : 'WAITTING',
      sra_users_id : null,
      internal_disabled : false,
      status_old : 'WAITTING',
      showApprovedDialog : false,
      selequipment : null,
      equipment_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      list_profile_se : [],
      sra_supplies_equipment_id : null,
      selsupplies : null,
      supplies_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      list_khoa_hoc : [],
      list_status_lesson : [
        {value: 'PASS', label: 'Đạt'},
        {value: 'FAILED', label: 'Chưa đạt'},
      ],
      list_tmp_course : [],
      list_coures_approved_v2 : [],
      showDialog : false,
      showDeleteDialog : false,
      lesson_users_deleted : null,
      show_gpvc : false,
      ep_data_date : [],
      ep_factory : null,
      ep_factory_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      ep_areas_obj : {
        offset: 0,
        filters: {},
        limit: 20,
        items: [],
        total: 0,
        loading: false
      },
      ep_areas : [],
      is_load_data : false,
      sra_entrance_permit_id : null,
      sample_license : {
        id : null,
        name : ''
      },
      edit_id : null,
      is_warning : false,
    };
  },
  async mounted() {
    this.type_company = this.$store.getters.typeCompany ?? null
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.is_required = false;
      if (this.$route.params.id !== undefined) this.detail_id = this.$route.params.id;
      console.log("this.model====",this.model)
      this.company = this.model.company;
      this.name = this.model.name;
      this.sra = this.model.sra;
      var contractor = this.model.contractor
      contractor.label = '['+contractor.code+'] '+contractor.name
      this.contractor = contractor
      if(this.model.daily_atw_sample_license){
        this.sample_license = this.model.daily_atw_sample_license.sample_license ?? {id : null, name : ''}
        this.edit_id = this.model.daily_atw_sample_license.id
      }
      this.getListDocumentFileAll()
    }
  },
  watch: {
    async "company_id"() {
      if ((this.$store.getters?.type != this.$constants.TYPE_USER.SUPPER_ADMIN)) {
        this.company = {id: this.company_id};
      }
    },
    
  },
  methods: {
    backToList() {
      this.$emit("back",this.seltype);
    },
    
    async validateData() {
      this.validationErrors = {};
      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async saveData() {
      // this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      var params = {
        company: this.company,
        list_profile : this.list_profile,
        files_deleted : this.filesDeletes2,
        note : this.note,
        files_deleted_root : this.filesDelete_root,
        daily_atw_sample_license_id : this.edit_id,
      };
      console.log("saveData", params);
      // this.$commonFuction.is_loading(false);
      this.$emit("save", params);
    },
    
    ShowUpload(index){
      this.index_update = -1;
      let profile = this.list_profile[index];
      console.log("profile==",profile.files)
      this.index_update = index;
      this.profile_info = {
        id : profile.id,
        created_at : profile.created_at,
        created_by : profile.created_by,
        files : profile.files ? JSON.parse(JSON.stringify(profile.files)) : [],
        sample_license_name : profile.sample_license_name,
        status : profile.status,
        time : profile.time ?? '',
        updated_at : profile.updated_at,
        updated_by : profile.updated_by,
        date_update : profile.date_update ?? null,
        license_criteria_id : profile.license_criteria_id ?? null,
        check_disable : profile.check_disable,
        status_check : profile.status_check,
        upload_disable : profile.upload_disable,
        ordinal : profile.ordinal ?? null,
        updated_fullname : profile.updated_fullname,
        daily_atw_sample_license_criteria_id : profile.daily_atw_sample_license_id
      }
      this.filesDeletes2_tmp = []
      this.filesDelete_root_tmp = []
      this.showEditDialog = true
    },
    async onFileSelect(event) {
      console.log("this.profile_info===",this.profile_info)
      let files = event.target.files || event.dataTransfer.files;
      console.log("files==",files)
      if (files.length > 0) {
        if (files.length > this.maxFiles) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFiles+" file");
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf."
            );
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFiles) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFiles + " files");
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            return;
          } else {
            // this.files = this.files.concat.apply(this.files, arrTemp);
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, arrTemp);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      return;
    },
    async onFileSelect2(event) {
      let files = event.target.files || event.dataTransfer.files;
      this.loading = true;
      console.log("files===",files)
      if (files.length > 0) {
        if (files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Chỉ được upload tối đa "+this.maxFilesProfile+" file");
          this.loading = false;
          return;
        }
        let acceptTags = [
          "docx", "doc", "xlsx", "pptx", "pdf","xls",
          "DOCX", "DOC", "XLSX", "PPTX", "PDF","XLS",
          "png", "jpg", "jpeg", "PNG", "JPG", "JPEG",
        ];
        for (let i = 0; i < files.length; i++) {
          if (!acceptTags.includes(files[i].name.split(".").pop())) {
            event.target.value = ""
            alert(
              "Vui lòng upload file có định dạng là: docx, doc, xlsx, pptx, pdf, png, jpg, jpeg."
            );
            this.loading = false;
            return;
          }
        }
        if (files.length + this.profile_info.files.length > this.maxFilesProfile) {
          event.target.value = "";
          alert("Số lượng tối đa là " + this.maxFilesProfile + " files");
          this.loading = false;
          return;
        } else {
          var arrTemp = [],
            arrFiles = [];
          for (let file of files) {
            console.log(file.type);
            // this.isImage(file){
              if (file.size <= this.maxFileSize) {
                file.source = file;
                file.objectURL = window.URL.createObjectURL(file);
                file.is_new = true;
                arrTemp.push(file);
              }else{
                arrFiles.push(file);
              }
            // }
          }
          // console.log("arrTemp",arrTemp)
          if (arrFiles.length > 0) {
            event.target.value = "";
            alert("File của bạn đã quá dung lượng 50MB");
            this.loading = false;
            return;
          } else {
            console.log("arrTemp===",arrTemp);
            var tmp_add = []
            await this.$CoreService.uploadImages(this.$constants.FOLDER_S3.DOCUMENT_FILES, arrTemp).then((resImage)=> {
              tmp_add = resImage
            })
            this.profile_info.files = this.profile_info.files.concat.apply(this.profile_info.files, tmp_add);
          }
        }
      }
      console.log("this.profile_info",this.profile_info)
      event.target.value = "";
      this.loading = false;
      return;
    },
    async EditData(){
      const tmp = this.profile_info
      console.log("this.tmp===",tmp)
      if(this.index_update >= 0){
        this.list_profile[this.index_update] = tmp;
      }
      this.showEditDialog = false
      this.profile_info = null;
      // console.log("filesDeletes2_tmp===",this.filesDeletes2_tmp)
      if(this.filesDeletes2_tmp.length > 0){
        this.filesDeletes2 = this.filesDeletes2.concat(this.filesDeletes2_tmp);
      }
      if(this.filesDelete_root_tmp.length > 0){
        this.filesDelete_root = this.filesDelete_root.concat(this.filesDelete_root_tmp);
      }
    },
    async onFileDownload(index) {
      let file = this.profile_info.files[index];
      window.open(file.url);
    },
    onFileClear(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file.file === "" && file.id) this.filesDeletes.push(file.id);
    },
    onFileClear2(index) {
      let file = this.profile_info.files[index];
      this.profile_info.files.splice(index, 1);
      if (file && file.is_old==true) this.filesDeletes2_tmp.push(file.id);
      
    },
    async getListDocumentFileAll() {
      if (this.$commonFuction.isEmptyObject(this.company)) {
        this.updateListProfile([])
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        };
        var object_id = this.edit_id ?? null
        if(!object_id){
          return
        }
        await ApiRepository.post("/_api/daily_atw/document_files", {datw_id : this.detail_id, object_id : object_id, company_id: this.company.id}, {headers}).then((res) => {
            var tmp_df = res.data.data.data ?? []
            var info = res.data.data.info ?? null
            // console.log("tmp_df===",tmp_df)
            // console.log("info===",info)
            this.updateListProfile(tmp_df,info)
        }).catch((err) => {
            console.log(err);
        })
      }
    },
    updateListProfile(list=[],info=null){
      if(info){
        this.note = info.note ?? ''
        if(this.note !== '' && this.type_company == 'contractor'){
          this.is_warning = true
        }
      }
      var tmp = []
      let type_company = this.$store.getters.typeCompany ?? null
      for (let i = 0; i < list.length; i++) {
        var status_check = false
        var check_disable = false
        var upload_disable = false
        if(list[i].status == 'APPROVED'){
          status_check = true
          check_disable = true
          upload_disable = true
        }else if(type_company == 'contractor'){
          check_disable = true
          if(list[i].status == 'APPROVED' || list[i].status == 'WAITTING'){
            upload_disable = true
          }
        }
        list[i].status_check = status_check
        list[i].check_disable = check_disable
        list[i].upload_disable = upload_disable
        var time = ''
        if(list[i].date_update){
          time = moment(list[i].date_update).format("DD/MM/YYYY HH:mm:ss")
        }
        list[i].time = time
        tmp.push(list[i])
      }
      console.log("tmp===",tmp)
      this.list_profile = tmp
    },
    async downloadFiles(data_file) {
      // this.displayDialogDownload = false;
      // console.log("click",data_file)
      var files = [];
      if(data_file){
        data_file.map(m=>{
          files.push({download: m.url, filename: m.name});
        })
      }
      // console.log("files",files)
      this.download_files(files);
    },
    download_files(files) {
      function download_next(i) {
        if (i >= files.length) {
          return;
        }
        var a = document.createElement('a');
        a.href = files[i].download;
        a.target = '_parent';
        // Use a.download if available, it prevents plugins from opening.
        if ('download' in a) {
          a.download = files[i].filename;
        }
        // Add a to the doc for click to work.
        (document.body || document.documentElement).appendChild(a);
        if (a.click) {
          a.click(); // The click method is supported by most browsers.
        } else {
          jq(a).click(); // Backup using jquery
        }
        // Delete the temporary link.
        a.parentNode.removeChild(a);
        // Download the next file with a small timeout. The timeout is necessary
        // for IE, which will otherwise only download the first file.
        setTimeout(function() {
          download_next(i + 1);
        }, 500);
      }
      // Initiate the first download.
      download_next(0);
    },
    async openFile(file) {
      try {
        const response = await fetch(file.url, { mode: "cors" }); // url từ server
        if (!response.ok) throw new Error("Không tải được file");

        console.log("response", response);

        const blob = await response.blob();

        let mimeType = blob.type;
        if (mimeType === "application/octet-stream") {
          const ext = file.name.split(".").pop().toLowerCase();
          if (["jpg", "jpeg", "png"].includes(ext)) {
            mimeType = "image/jpeg";
          } else if (ext === "pdf") {
            mimeType = "application/pdf";
          }
        }
        console.log("mimeType", mimeType);

        const fixedBlob = new File([blob], file.name, { type: mimeType });
        const objectURL = URL.createObjectURL(fixedBlob);
        
        // nếu là PDF hoặc ảnh thì mở online trong tab mới
        if (mimeType.includes("pdf") || mimeType.includes("image")) {
          window.open(objectURL, "_blank"); // giờ sẽ hiển thị online
        } else {
          const link = document.createElement("a");
          link.href = objectURL;
          link.download = file.name || file.url.split("/").pop();
          link.click();
        }

      } catch (err) {
        console.error("Không mở được file:", err);
        alert("Không mở được file");
      }
    },
  },
  
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.f-grid {
  display: flex;
  justify-content: space-between;
  margin-left: -1rem;
  flex-flow: row wrap;
}
.f-grid-col {
  flex: 1 0;
  /* background-color: #EEEEEE; */
  padding: 0rem 1rem 0rem 1rem;
  border-radius: 5px;
}
#customers {
  border-collapse: collapse;
  width: 100%;
}
.cs-width {
  width : 100% !important;
}
.cs-input {
  width : 100%;
  /* max-width: 400px !important; */
}
.title-css { 
  font-weight: bold;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td {
  border: 1px solid #ddd;
  padding: 6px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
}
.p-button-cancel-2 {
  color : #333333;
  background-color : #F2F3F7;
  border: 1px solid #F2F3F7;
}
.download-file-cs {
  color : #0086C4;
  text-decoration: underline;
  cursor: pointer;
}
.input_tmp_validator_r {
  display : block;
  width: 0px !important;
  height: 0px !important;
  background-color: #ffffff;
  border: unset;
  outline: unset;
  left: 1em;
}
#kdt_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

#kdt_tab td {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
  /* vertical-align: top; */
}
#kdt_tab th {
  border: 1px solid #ddd;
  padding: 5px 5px 5px 5px;
  height: 40px;
}
#kdt_tab th {
  padding-top: 5px;
  padding-bottom: 5px;
  text-align: left !important;
  background-color: #F4F4F4;
}
.cs-warning-cls {
  /* background-color:rgb(255, 0, 0);
  color: #ffffff; */
}
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.7);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 5px solid #ccc;
  border-top: 5px solid #42b983;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

</style>
